export default __webpack_public_path__ + "static/media/Age.ef3b230f.jpg";